import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-21c6d342")

_pushScopeId("data-v-21c6d342")
const _hoisted_1 = {
  key: 0,
  class: "sign-in"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "sub-text1" }, "半角のアルファベットと数字両方を含む6〜20文字", -1)
const _hoisted_3 = {
  key: 0,
  class: "error"
}
const _hoisted_4 = {
  key: 1,
  class: "sign-in"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "sub-text1" }, "半角のアルファベットと数字両方を含む6〜20文字", -1)
const _hoisted_6 = {
  key: 0,
  class: "error"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TextField = _resolveComponent("TextField")
  const _component_BaseRoundRectButton = _resolveComponent("BaseRoundRectButton")
  const _component_ValidationObserver = _resolveComponent("ValidationObserver")
  const _component_SelectBox = _resolveComponent("SelectBox")

  return (_ctx.state.isEmailSignIn)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_ValidationObserver, { ref: "form" }, {
          default: _withId(() => [
            _createVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createVNode(_component_TextField, {
                class: "input-phoneNumber",
                label: "メールアドレス",
                type: "email",
                modelValue: _ctx.state.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.email = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_TextField, {
                label: "パスワード",
                modelValue: _ctx.state.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.password = $event))
              }, null, 8, ["modelValue"]),
              _createVNode("p", null, _toDisplayString(_ctx.password), 1),
              _hoisted_2,
              (_ctx.localizationError != null)
                ? (_openBlock(), _createBlock("p", _hoisted_3, _toDisplayString(_ctx.localizationError.message), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_BaseRoundRectButton, {
                class: "login-button",
                text: "ログイン",
                onClick: _ctx.emitSignInWithEmail,
                isPushed: _ctx.isLoading
              }, null, 8, ["onClick", "isPushed"]),
              _createVNode("p", {
                class: "sub-text2 border",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeSignInMethod(false)))
              }, "電話番号ログインはこちら")
            ], 32)
          ]),
          _: 1
        }, 512)
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_4, [
        _createVNode(_component_ValidationObserver, { ref: "form" }, {
          default: _withId(() => [
            _createVNode("form", {
              onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createVNode(_component_SelectBox, {
                class: "select-box",
                modelValue: _ctx.state.countryCode,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.countryCode = $event)),
                options: _ctx.countryCodeOptions
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_component_TextField, {
                class: "input-phoneNumber",
                label: "電話番号",
                type: "number",
                modelValue: _ctx.state.phoneNumber,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.phoneNumber = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_TextField, {
                label: "パスワード",
                modelValue: _ctx.state.password,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.password = $event))
              }, null, 8, ["modelValue"]),
              _createVNode("p", null, _toDisplayString(_ctx.password), 1),
              _hoisted_5,
              (_ctx.localizationError != null)
                ? (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.localizationError.message), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_BaseRoundRectButton, {
                class: "login-button",
                text: "ログイン",
                onClick: _ctx.emitSignInWithPhoneNumber,
                isPushed: _ctx.isLoading
              }, null, 8, ["onClick", "isPushed"]),
              _createVNode("p", {
                class: "sub-text2 border",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeSignInMethod(true)))
              }, "メールアドレスログインはこちら ")
            ], 32)
          ]),
          _: 1
        }, 512)
      ]))
})